<template>
	<div>
		<div v-if="!saved">
			<v-row v-for="(question, i) in questions" :key="i">
				<v-col v-if="question.type == 'text-field'">
					<v-text-field :label="question.label" v-model="answers[question.value]"></v-text-field>
				</v-col>
				<v-col v-if="question.type == 'textarea'">
					<v-textarea :label="question.label" v-model="answers[question.value]"></v-textarea>
				</v-col>
				<v-col v-if="question.type == 'select'">
					<v-select :label="question.label" v-model="answers[question.value]" :items="question.items"></v-select>
				</v-col>
			</v-row>

			<p class="text-right">
				<v-btn color="green" dark @click="save">Save </v-btn>
			</p>
		</div>
		<v-alert v-else>Thank you for your message!</v-alert>
	</div>
</template>

<script>
	import axios from 'axios'
	export default {
		name: "ContactForm", 
		props: {
			id: {type: String},
			questions: {type: Array}
		}, 
		data: () => {
			return {
				answers: {},
				saved: false, 
				ip: false, 
				uag: false
			}
		},
		methods: {
			async getIP(){
				return await axios.get(`https://www.cloudflare.com/cdn-cgi/trace`)
			},
			save(){
				const self = this;
				var data = {
					responses: self.answers,
					formId: self.id,
					ip: self.ip, 
					userAgentString: self.uag
				}; 
				self.$store.dispatch("addDoc", {
					collection: "contactFormEvents", 
					data: data
				}).then( () => {
					self.saved = true;
				})
			}
		}, 
		created() {
			const self = this;
			self.getIP().then( data => {
				data = data.data;
				var obj = {}
				data.split("\n").forEach( line => {
					var keyed = line.split("=");
					obj[keyed[0]] = keyed[1];
				})
				self.ip = obj.ip;
				self.uag = obj.uag;
			})
		}
	}
</script>